import React from 'react';
import NavigationBar from '../../../components/common/ui/NavigationBar';

const Header = (props) => <NavigationBar title={props.title} func={props.functionLogic} />;
export default Header;
